export enum Browser {
  Safari = "Safari",
  Chrome = "Chrome",
  Firefox = "Firefox",
  Ie = "Ie",
  Edge = "Edge"
}
